/** Shared short risk-disclosure copy for the public website. */
export const RISK_LINKS = {
  disclosure: '/risk-disclosure',
  terms: '/terms',
  privacy: '/privacy',
  /** Absolute destinations for Client Portal pages hosted off the marketing site. */
  disclosureAbsolute: 'https://www.perfectpredict.com/risk-disclosure',
  termsAbsolute: 'https://www.perfectpredict.com/terms',
  privacyAbsolute: 'https://www.perfectpredict.com/privacy',
  support: 'https://portal.perfectpredict.com/app/support',
} as const

export const HERO_RISK_NOTICE = 'Trading involves risk. Returns are not guaranteed.'

export const STRATEGY_RISK_DISCLOSURE =
  'Illustrative examples only. These figures do not represent guaranteed returns. Actual outcomes depend on market movement, execution conditions and the selected strategy. Trading involves the risk of loss.'

export const FINAL_CTA_RISK_NOTICE =
  'Trading involves risk. You may lose some or all of your invested capital. Review the Risk Disclosure before opening a Live Trading Account.'

export const FOOTER_RISK_WARNING =
  'Trading leveraged financial instruments involves a high level of risk and may not be suitable for all investors. You may lose some or all of your invested capital. Strategy parameters and payout illustrations shown on this website are examples only and do not guarantee any trading outcome. Perfect Predict does not provide investment advice or guarantee profits. Please review the Risk Disclosure before opening a Live Trading Account.'

export const REGISTER_RISK_NOTICE =
  'By creating an account, you acknowledge that trading involves risk and that returns are not guaranteed. Please review the Terms, Privacy Policy and Risk Disclosure.'

export const PREVIEW_FIGURES_NOTE =
  'Illustrative figures only. Outcomes are not guaranteed.'
